import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ComputeService } from './compute-service.component';
import { JobConstants } from '../../../../../common/utils/job-constants';
import { AuthService } from '../../../../auth/auth.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../refresh-shared-service';
import { storagePrettyConverter, checkIfUserHasRoles } from '../../../../../common/utils/utils';

@Component({
  selector: 'dashboard-compute',
  providers: [ ComputeService, TranslateService],
  styles: [require('./compute-dashboard.scss')],
  templateUrl: './compute-dashboard.component.html'
})

export class ComputeDashboard {

  private orgCount: number = 0;
  private vdcCount: number = 0;
  private vmCount: number  = 0;
  private vmPoweredOnCount: number   = 0;
  private vmPoweredOffCount: number  = 0;
  private cpuData: any;
  private cpuPieChartData: any;
  private cpuPieChartOptions: any;
  private memoryData: any;
  private memoryPieChartData: any;
  private memoryPieChartOptions: any;
  private storageData: any;
  private storagePieChartData: any;
  private storagePieChartOptions: any;

  private computeSummary: any;
  private isDataLoaded: boolean = false;

  private rsService: RefreshSharedService;
  private refreshSubscription: Subscription;
  private currentClassName: string = '';
  private loaded: boolean = false;
  private isActivityLogVisible: boolean = false;
  private admininstratorView: boolean = false;

  private activityLogService = JobConstants.SERVICES['NetworkingServiceJobV1'];
    private activityLogFilter = 'workflowType='
        + JobConstants.WORKFLOW_JOB_TYPES.CREATE_ORGANIZATION_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.UPDATE_ORGANIZATION_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.DELETE_ORGANIZATION_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.CREATE_ORG_VDC_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.UPDATE_ORG_VDC_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.DELETE_ORG_VDC_JOB + ','
        + JobConstants.WORKFLOW_JOB_TYPES.UPDATE_ORG_VDC_STORAGE_PROFILES_JOB;

  constructor(private service: ComputeService,
              private translateService: TranslateService,
              public authService: AuthService,
              private rss: RefreshSharedService) {
    translateService.use(GlobalVariables.LOCALE);
        let roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if ( checkIfUserHasRoles(roles) ) {
            this.admininstratorView = true;
        } else {
            this.admininstratorView = false;
        }
        this.rsService = rss;
        this.currentClassName = 'ComputeDashboard';
  }

  ngOnInit() {
      this.refreshSubscription = this.rsService.getRefreshParam()
      .subscribe (
        item => {
          this.handleEmittedValues(item);
      });
      this.rsService.setParam({
          'loadedComponent': this.currentClassName,
          'detailPageIDName': '',
          'shouldReloadInventoryTree': false
      });
      this.getComputeData();
  }

   handleEmittedValues(item) {
      if (item.loadedComponent === this.currentClassName) {
            this.getComputeData();
      }
  }

  getComputeData() {
    this.loaded = false;
    this.service.getComputeSummary()
    .subscribe(
     data => {
       this.loaded = true;
       this.computeSummary = data;
       this.orgCount = this.computeSummary.orgCount;
       this.vdcCount = this.computeSummary.vdcCount;
       this.vmCount  = this.computeSummary.vm
       && this.computeSummary.vm.vmCount
       ? this.computeSummary.vm.vmCount
       : 0;
       this.vmPoweredOnCount  = this.computeSummary.vm
       && this.computeSummary.vm.poweredOnVmCount
       ? this.computeSummary.vm.poweredOnVmCount
       : 0;
       this.vmPoweredOffCount  = this.computeSummary.vm
       && this.computeSummary.vm.poweredOffVmCount
       ? this.computeSummary.vm.poweredOffVmCount
       : 0;


       // CPU Pie Chart Data & Options
       this.cpuData = this.computeSummary.properties
       && this.computeSummary.properties.cpu
       ? this.computeSummary.properties.cpu
       : {};
       this.cpuData.usedPercentage = (this.cpuData && this.cpuData.used && this.cpuData.allocated)
       ? this.calculatePercentage(this.cpuData.used, this.cpuData.allocated) : 0;
       this.cpuData.usedPercentageLen = (this.cpuData && this.cpuData.usedPercentage)
       ? this.cpuData.usedPercentage.length
       : 0;
       this.cpuData.usedWithUnit = storagePrettyConverter( this.cpuData.used, this.cpuData.unit );
       this.cpuData.allocatedWithUnit = storagePrettyConverter( this.cpuData.allocated, this.cpuData.unit );
       this.cpuPieChartData = {
         labels: [this.translateService.instant('computeModule.dashboard.dashboard.used') + " " + this.cpuData.usedWithUnit,
         this.translateService.instant('computeModule.dashboard.dashboard.allocated') + " " + this.cpuData.allocatedWithUnit],
         datasets: [
           {
             data: [this.cpuData.used, this.cpuData.allocated - this.cpuData.used],
             backgroundColor: [(this.cpuData.allocated - this.cpuData.used) > 0
             ? '#007CBB' : '#D0011B']
           }
         ]
       };
      this.cpuPieChartOptions = {
        scaleShowVerticalLines: false,
        responsive: true,
        legend: {
            display: false,
            position: 'top'
        },
        cutoutPercentage : 75,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var labelIndex  = (tooltipItem && tooltipItem.index >=0 ) ? tooltipItem.index : null;
              var realLabel   = (data && data.labels && labelIndex >=0) ? data.labels[labelIndex] : null;
              return realLabel;
            }
          }
        }
      };


       // Memory Pie Chart Data & Options
       this.memoryData = this.computeSummary.properties
       && this.computeSummary.properties.memory
       ? this.computeSummary.properties.memory
       : {};
       this.memoryData.usedPercentage = (this.memoryData && this.memoryData.used && this.memoryData.allocated)
       ? this.calculatePercentage(this.memoryData.used, this.memoryData.allocated) : 0;
       this.memoryData.usedPercentageLen = this.memoryData && this.memoryData.usedPercentage
       ? this.memoryData.usedPercentage.length
       : 0;
       this.memoryData.usedWithUnit = storagePrettyConverter( this.memoryData.used, this.memoryData.unit );
       this.memoryData.allocatedWithUnit = storagePrettyConverter( this.memoryData.allocated, this.memoryData.unit );
       this.memoryPieChartData = {
         labels: [this.translateService.instant('computeModule.dashboard.dashboard.used') + " " + this.memoryData.usedWithUnit,
         this.translateService.instant('computeModule.dashboard.dashboard.allocated') + " " + this.memoryData.allocatedWithUnit],
         datasets: [
           {
             data: [this.memoryData.used, this.memoryData.allocated - this.memoryData.used],
             backgroundColor : [(this.memoryData.allocated - this.memoryData.used) > 0
             ? '#007CBB' : '#D0011B']
           }
         ]
       };
      this.memoryPieChartOptions = {
        scaleShowVerticalLines: false,
        responsive: true,
        legend: {
            display: false,
            position: 'top'
        },
        cutoutPercentage : 75,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var labelIndex  = (tooltipItem && tooltipItem.index >=0 ) ? tooltipItem.index : null;
              var realLabel   = (data && data.labels && labelIndex >=0) ? data.labels[labelIndex] : null;
              return realLabel;
            }
          }
        }
      };


       // Storage Pie Chart Data & Options
       this.storageData = this.computeSummary.properties
       && this.computeSummary.properties.storage
       ? this.computeSummary.properties.storage
       : {};
       this.storageData.usedPercentageLen = this.storageData && this.storageData.usedPercentage
       ? this.storageData.usedPercentage.length
       : 0;
       this.storageData.usedWithUnit = storagePrettyConverter( this.storageData.used, this.storageData.unit );
       this.storageData.allocatedWithUnit = storagePrettyConverter( this.storageData.allocated, this.storageData.unit );
        this.storagePieChartData = {
          labels: [this.translateService.instant('computeModule.dashboard.dashboard.used') + " " + this.storageData.usedWithUnit,
          this.translateService.instant('computeModule.dashboard.dashboard.allocated') + " " + this.storageData.allocatedWithUnit],
          datasets: [
            {
              data: [this.storageData.used, this.storageData.allocated - this.storageData.used],
              backgroundColor: [(this.storageData.allocated - this.storageData.used) > 0
              ? '#007CBB' : '#D0011B']
            }
          ]
        };
        this.storagePieChartOptions = {
          scaleShowVerticalLines: false,
          responsive: true,
          legend: {
              display: false,
              position: 'top'
          },
          cutoutPercentage : 75,
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var labelIndex  = (tooltipItem && tooltipItem.index >=0 ) ? tooltipItem.index : null;
                var realLabel   = (data && data.labels && labelIndex >=0) ? data.labels[labelIndex] : null;
                return realLabel;
              }
            }
          }
        };

        this.isDataLoaded = true;
      },
      error => { window.alert(error); }
    );
  }

  calculatePercentage(value, maxValue) {
    return maxValue ? ((Number(value) / Number(maxValue)) * 100).toFixed(2).toString() : 0;
  }

  setUsedServiceStyles(len) {
      let marginLeft = '33%';
      if (len === 1) {
        marginLeft = '38%';
      } else if (len === 3 ) {
        marginLeft = '28%';
      } else if (len > 3 ) {
        marginLeft = '23%';
      }
      let styles = {
        'left':  marginLeft
      };
      return styles;
  }

  onTabIndexChanged(event){
      if (event === 0) {
         this.rsService.setParam({
            'loadedComponent': this.currentClassName,
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
         });
      }
      this.isActivityLogVisible = (event === 1) ? true : false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/dashboard/compute-dashboard.component.ts